export default (context, info) => {
    if(info.type === 'video' ) {
        if(context.main[info.index]) {
            if(context.main[info.index].type === 'text') {
                context.set_popups(context, { overlay: true,  moreText: false, growButton: false, value: true, text: 'Видео можно удалить только со следующим за ним текстовым блоком.'})
            }
        } else {
            context.set_popups(context, { overlay: true,  moreText: false, growButton: false, value: true, text: 'Удалить это видео?'})
        }
    } else if(info.type === 'text') {
        if(context.main[info.index]) {
            if(context.main[info.index].type === 'video') {
                context.set_popups(context, { overlay: true,  moreText: false, growButton: false, value: true, text: 'Текстовый блок можно удалить только со следующим за ним видео.'})
            }
        } else {
            context.set_popups(context, { overlay: true,  moreText: false, growButton: false, value: true, text: 'Удалить этот текстовый блок?'})
        }
    } else if(info.type === 'music') {
        context.set_popups(context, { overlay: true,  moreText: false, growButton: false, value: true, text: 'Удалить это музыкальное сопровождение?'})
    }
}